"use client";

import { Provider } from "jotai";

import { XStore } from "@/src/helpers/storeHelper";

interface IProps {
  children: React.ReactNode;
}

export default function StoreProvider({ children }: IProps) {
  return <Provider store={XStore}>{children}</Provider>;
}
